import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css"; // You can put styles in a separate CSS file

const Dream11Channel = () => {
  return (
    <div className="dream11-container">
      <div className="overlay"></div>

      <div className="container text-center">
        <h1>👑 Aryan Guruji Fantasy King👑</h1>
        <p className="subheading">( JOIN FOR FANTASY TEAM )</p>
        <p className="subheading">🔥 The #1 Telegram Channel for Fantasy Team ✍</p>

        <a href="https://t.me/+h5tUer6MHwc4MWM1">
          <img src="images\aryanguru.jpeg" alt="Profile" className="profile-image" />
        </a>

        <p className="mt-3">👑 Aryan Guruji - Bet Smart, Win Big! Join Now! 💯🎁</p>

        <a href="https://t.me/+h5tUer6MHwc4MWM1" className="btn btn-primary">
          JOIN OUR TELEGRAM CHANNEL
        </a>

        <p className="mt-3">#1 Telegram Channel for Fantasy Team ✍ - Join Now! 👑</p>
      </div>
    </div>
  );
};

export default Dream11Channel;
